var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tip-placeholder",class:{'reversed': true === _vm.reversed}},[_c('i',{staticClass:"icon"},[_vm._v("")]),_c('span',{staticClass:"text"},[_vm._v("点击此处上传"+_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }